import { html } from 'lit';
import axios from "axios";
import { Constants, CookieService, AlertMessagesService, Utils, MediaOpsService, authansid } from '../../../shared';
import { CreatePlacementOrPackageService, PlacementUtils } from "../";

export const PlacementDetailsTableService = {

    /**
     *  function to validate the correct the date string in MMM DD, YYYY format to match below converDateToYMDFormat function and to maintain consistency
     * @param {dateString} string - date string
     * @returns {boolean} - true if the given string is in valid 
     *  */ 
    isValidDateString: (dateString) => {
        const dateRegex = /^([A-Za-z]{3})\s(\d{1,2}),\s(\d{4})$/i;
        // Helper function to get month number from month name
        dateRegex.getMonthNumber = function(monthName) {
            const monthNames = {
              jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
              jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
            };
            return monthNames[monthName.toLowerCase()];
          };

        const matches = dateString.match(dateRegex);

        if (!matches) {
            // If the string doesn't match the format, return false
            return false;
        }

        // Check if the date is valid
        const monthName = matches[1];
        const day = parseInt(matches[2], 10);
        const year = parseInt(matches[3], 10);
        const date = new Date(`${monthName} ${day}, ${year}`);

        return (
            date.getFullYear() === year &&
            date.getMonth() === dateRegex.getMonthNumber(monthName) &&
            date.getDate() === day
        );
    },

    converDateToYMDFormat: (dateString) => {
        if(dateString){ 
        const dateParts = dateString.split(" ");
        const month = dateParts[0].toUpperCase();
        const day = dateParts[1].replace(",", "");
        const year = dateParts[2];
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        const formattedDate = year + "-" + (months.indexOf(month) + 1).toString().padStart(2, "0") + "-" + day.padStart(2, "0");
        return formattedDate;
        }else{
            return dateString;
        }
    },

    /**
     * create placement payload data for API 
     * @param {object} placementObj placement detail 
     * @returns {object} payload- payload object
     */
    prepareCopyPayload: (placementObj, omniProfile = {}) => {
        const isOverride = placementObj["override_taxonomy"];
        let name =( isOverride ?  placementObj['overriden_placement_taxonomy']  :  placementObj['placement_taxonomy'] );
        const payload = {
            "packageType": placementObj.package_type,
            "placementCost": {
                "unitAmount": placementObj.unit_amount,
                "plannedCost": {
                    "amount": placementObj.planned_cost
                },
                "rate": {
                    "amount": placementObj.rate
                }
            },
            "placementNumber": null,
            "placementTaxonomy":name,
            "placementTaxonomyDisplay": placementObj.placement_taxonomy_display,
            "overridenPlacementTaxonomy" : placementObj.overriden_placement_taxonomy,
            "overridenPlacementTaxonomyDisplay" : placementObj.overriden_placement_display_taxonomy,
            "parameterCode": placementObj.parameter_code,
           "parameterCodeTaxonomyDisplay":  placementObj.parameter_code_taxonomy_display,
            "parameterCodeTaxonomySchema": placementObj.parameter_code_taxonomy_schema,
            "parentId":  placementObj.parent_id?.toString(),
            "taxonomySchema":  placementObj.taxonomy_schema,
            "placementType": placementObj.placement_type,
            "buyCategory": placementObj.buy_category,
            "unitType": placementObj.unit_type,
            "costMethod": placementObj.cost_method,
            "costType": placementObj.cost_type,
            "site": placementObj.site,
            "dimensionsPosition": placementObj.dimensions_position,
            "dimensions": placementObj.dimensions,
            "flightStart": placementObj.flight_start,
            "flightEnd": placementObj.flight_end,
            "servedBy": placementObj.served_by,
            "dataSource": placementObj.data_source,
            "primaryPlacement": placementObj.primary_placement,
            "marketValue": placementObj.market_value,
            "provider": placementObj.provider,
            "createdBy": omniProfile?.email,
            "overrideTaxonomy" : isOverride,
            "id": placementObj.id?.toString()
        }
        return payload;
    },

    /**
     * Export POST API to export the selected placement from placement table
     * @function exportPlacements
     * @param {Array} placements selected placement array
     * @param {String} camapignId selected campaign Id
     * @param {Object} payload campaign payload
     * @param {String} versionOneApi version one boolean value
     * @param {Array} pmdsItems pmds items
     * @returns {Object} response object 
    */
    exportPlacements: (placements, camapignId, payload, versionOneApi, pmdsItems) => {
        const url = Constants.ExportPlacementsUrl;
        const placementsIdsArray = placements.map(placementObj =>  placementObj.id);
        let pmdsItemsArray = pmdsItems.map(pmdsItem => pmdsItem.tier_id);
         const requestUrl = url + Utils.getRouteParam("clientid") + "?campaign-id=" + camapignId + "&type=placement";
        payload['placement-ids'] = placementsIdsArray;
        payload['tier-ids'] = pmdsItemsArray;
        return axios.post(requestUrl,payload,{
            headers: {
                ansid: CookieService.getCookie("ANsid"),
                clientid: Utils.getRouteParam("clientid"),
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        }).then((response) => {
          return response && response.data;
        }, (error) => {
          return Promise.reject(error);
        })
    },

     /**
     * API have respose export job is pending or completed
     * @param {Object} payload  with job id
     * @returns {Object} response object 
    */
    checkExportJobStatus: (payload) => {
        const url = Constants.ClientDataUrl;
        const jobId = payload.jobId;
        const clientId = Utils.getRouteParam("clientid")
        const requestUrl = `${url}/${clientId}/async-job-status/${jobId}`;
        return axios.get(requestUrl,{
            headers: {
                ansid: CookieService.getCookie("ANsid"),
                clientid: Utils.getRouteParam("clientid"),
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        }).then((response) => {
          return response && response.data;
        }, (error) => {
          return Promise.reject(error);
        })
    },
    
    /**
    * Formats a number to display two digits after the decimal point as a currency value in USD.
    * @param {number|string} number - The number to be formatted.
    * @param {boolean} [isItAuthorizedAmount=false] - Indicates whether the number represents an authorized amount.
    * @returns {string} The formatted currency value or an empty string if the input is invalid or empty.
    */
    getNumberWithTwoDigitsAfterDecimal : (number, isItAuthorizedAmount = false,currencyName = 'USD') => {
        if (isItAuthorizedAmount && (number === null || number === '' || number === undefined)) {
                return '';
        }
        let num = number
        if (typeof number === 'string') {
            if(number === ""){
                return '';
            }
            num = Number(number)
            if (isNaN(num)) {
                return ''
            }
        }
        if (typeof num === 'number') {
            num = num.toLocaleString('en-US', {
                style: 'currency',
                currency: currencyName || 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return num;
        }
        return ''
    },

        /**
         * The below code is a JavaScript function that checks if the value of `value.package_type` is not
         * equal to either "Child" or "DSP". If it is not, it calls the `getNumberWithTwoDigitsAfterDecimal`
         * function from the `PlacementDetailsTableService` and passes `value.planned_cost` as an argument. The
         * function returns the result of this function call. If the value of `value.package_type` is either
         * "Child" or "DSP", the function returns an empty string.
         * @param {Object} value 
         * @param {Number} index 
         * @returns 
         */
        getPlannedCost : (value, index,isLocal, currency) => {
            let plannedCost = null
            if(isLocal){
                plannedCost = value?.planned_cost_local || value.plannedCostLocal;
            }else{
                plannedCost = value?.planned_cost || value.plannedCost;
            }
            // plannedCostNumber = isLocal && value?.planned_cost_local ? value?.planned_cost_local  : value?.planned_cost ;
            // const plannedCost = value.planned_cost ? value.planned_cost : value.plannedCost ? value.plannedCost : null;
                return PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(plannedCost,false,currency);
        },
    
        /**
         * hide units for child (package_type)
         * the third && condition is use to check if unit is there oterwise hide rate input box, or if rate is only zero and cost method is flat
         * @param {Object} value - The value object.
         * @param {number} index - The index value.
         * @returns {string} - The formatted unit amount as a string, or an empty string if the conditions are not met.
         */
        getUnits : (value) => {
            if ((value.package_type !== 'Child' || value.parent_type === 'Package' ) && 
            value.package_type !== "DirectCreative" && 
            value.package_type !== "DirectLine" &&
            value.unit_amount) {
              return value.unit_amount.toLocaleString('en-US');
            } else {
              return '';
            }
        },
        
        /**
         * Calculate the ad fee based on the given value and field.
         * @param {Object} value - The input value, typically containing package_type and the specified field.
         * @param {string} field - The field used to calculate the ad fee.
         * @returns {string} - The calculated ad fee formatted with two digits after the decimal point,
         *  or an empty string if the conditions are not met.
         */
        getAdFee : (value, field) => {
            if ((value.package_type !== 'Child' || value.parent_type === 'Package') && value.package_type !== "DirectCreative" && value[field]) {
                return PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(value[field]);
            } else {
              return '';
            }
        },

        /**
         * hide rate for child (package_type)
         * the third && condition is use to check if rate is there oterwise hide rate input box, or if rate is only zero and cost method is flat
         * @param {Object} value - The value object.
         * @param {number} index - The index value.
         * @returns {string} - The formatted rate as a string with USD currency symbol, or an empty string if the conditions are not met.
         */
        getRate : (value, isLocal=false, currency='USD') => {
            let field = isLocal && currency ?  'rate_local' : 'rate';

            if ((value.package_type !== 'Child' || value.parent_type === 'Package') && 
                value.package_type !== "DirectCreative" && 
                value.package_type !== "DirectLine" &&
                (value[field] || (value.rate == 0 && value.cost_method === "Flat"))) {
              return value[field]?.toLocaleString('en-US', {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            }
            return '';
        },

        /**
        * Gets the ad server fee as a formatted string.
        *
        * @param {Object} value - The value object containing the ad server fee property.
        * @returns {string} The formatted ad server fee as a string.
        */
        getAdServerFee: (value) => {
            return value?.ad_server_fee?.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        /**
         * Gets the ad verification fee as a formatted string.
         *
         * @param {Object} value - The value object containing the ad verification fee property.
         * @returns {string} The formatted ad verification fee as a string.
         */
        getAdVerificationFee: (value) => {
            return value?.ad_verification_fee?.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
    
        // hide dimensions for child (package_type)
        getDimensions : (value, index) => {
            if ((value.package_type !== 'Child' || value.parent_type === 'Package') && value.package_type !== "DirectCreative") {
                return value.dimensions;
            } else {
                return '';
            }
        },

        // API call for bulk create on uploading the excel file
        importPlacements: (campaignId, placementsToImports, versionOneApi) => {
            const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
            return axios
            .post(url + '/' + campaignId + '/placements/bulk-create' + '?client-id=' + Utils.getRouteParam("clientid") + '&type=placement',  
            placementsToImports,
            {headers: {
                ansid: authansid,
                clientid: Utils.getRouteParam("clientid")
              }})
            .then((response) => {
                return response;
            })
        },

        /** 
         *  This function called `getOmniIconDisableOptions`.will help to disable the menu when the no checkboxes
         *  are selected and will enable once we select the checkboxes.
         * @param { object } `selectedItems` an array object
         */
            getOmniIconDisableOptions: (selectedItems) =>{ 
            let iconMenuDisabled = {};
            if(!selectedItems.length){
                iconMenuDisabled["disabled"] = true;
            }
            return iconMenuDisabled;
        },

    /** 
    * Description: This is a function called `sortPlacements` that takes in three parameters: `campaignName`,
    * `sortColumn`, and `sortOrder`. It makes an HTTP GET request to a specific URL with the
    * `campaignName` parameter included in the URL path and the `sortColumn` and `sortOrder` parameters
    * included as query parameters. It also includes a header with an ANsid cookie value obtained from a
    * `CookieService` function. This function is likely used to retrieve sorted placement data for a specific
    * campaign.
    * @param {string} campaignName
    * @param {string} sortColumn column name for sorting
    * @param {string} sortOrder Asc || Desc
    * @param {Array} filterIds comma separated placement ids to filter
    * @returns {Promise} Promise that resolves with the response data or rejects with an error.
    */
    sortPlacements: (campaignName, sortColumn, sortOrder, is_deleted, filterIds, versionOneApi = 'V1') => {
        const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
        let sortParams = {
            "sort-column": sortColumn,
            "sort-order": sortOrder,
            "is_delete": is_deleted
        }
        if(filterIds){
            sortParams["placements"] = filterIds;
        }
        return axios
            .get(url + "/" + campaignName + "/placements?includeDeliveredTaxonomies=true",
                {
                    params: sortParams,
                    headers: {
                        ansid: CookieService.getCookie("ANsid"),
                        clientid: Utils.getRouteParam("clientid")
                    }
                })
            .then((response) => {
                return response && response.data;
            }, (error) => {
                return Promise.reject(error);
            })
    },

    /** 
    * The above code is defining a function called `sendToMediaOcean` that takes in two parameters:
    * `payload` and `campaignId`. The function constructs a `requestUrl` using the `campaignId` and
    * `payload.ids` (if it exists), and then sends a PUT request to that URL using Axios. The `ansid`
    * header is set using a value retrieved from a cookie. The function returns a Promise that resolves
    * with the response from the PUT request. 
    */
    sendToMediaOcean: (payload, campaignId, versionOneApi) => {
        const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
        let requestUrl = url + "/" + campaignId + "/placements";
        if (payload.ids.length === 1) {
            requestUrl += "/" + payload.ids[0];
            delete payload.ids;
        }
        return axios
            .put(requestUrl,
                payload,
                {
                    headers: {
                        ansid: CookieService.getCookie("ANsid"),
                        clientid: Utils.getRouteParam("clientid")
                    }
                })
            .then((response) => {
                return response;
            })
    },

    /**
     * The below code is defining a function called `getPlacementsApproved` that takes in three parameters:
     * `requestUrl`, `payload`, and `pathParameters`. The function sends a PUT request to the `requestUrl`
     * using Axios, with the `payload` as the request body and the `pathParameters` as query parameters. The
     * `ansid` and `clientid` headers are set using values retrieved from cookies. The function returns a
     * Promise that resolves with the response from the PUT request.
     * @param {string} requestUrl
     * @param {object} payload
     * @param {object} pathParameters
     * @returns {Promise} Promise that resolves with the response data or rejects with an error.
     */
    getPlacementsApproved: (campaignId, payload, pathParameters, versionOneApi) => {
        const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
        return axios
        .put(url + "/" + campaignId + "/placements",
        payload,
          {
            params: pathParameters,
            headers: {
              ansid: CookieService.getCookie("ANsid"),
              clientid: Utils.getRouteParam("clientid")
            }
          })
        .then((response) => {
          return response;
        })
      },

    /**
     * Parallel chunked version of getPlacementsApproved that splits large ID arrays into chunks of 500 items each.
     * Processes all chunks in parallel and returns aggregated results. If any chunk fails, the entire operation fails.
     * @param {string} campaignId - Campaign ID
     * @param {object} payload - Payload containing approvedBy, isApproved, and ids array
     * @param {object} pathParameters - Path parameters for the request
     * @param {string} versionOneApi - API version
     * @returns {Promise} Promise that resolves with aggregated response data or rejects with an error.
     */
    getPlacementsApprovedChunked: (campaignId, payload, pathParameters, versionOneApi) => {
        const CHUNK_SIZE = 300;
        const { approvedBy, isApproved, ids } = payload;
        
        if (!ids || ids.length === 0) {
            return Promise.reject(new Error('No placements to approve'));
        }
        
        if (ids.length <= CHUNK_SIZE) {
            return PlacementDetailsTableService.getPlacementsApproved(campaignId, payload, pathParameters, versionOneApi);
        }

        const chunks = [];
        for (let i = 0; i < ids.length; i += CHUNK_SIZE) {
            chunks.push(ids.slice(i, i + CHUNK_SIZE));
        }

        const chunkifiedPlacmentPromises = chunks.map((chunk, index) => {
            const chunkPayload = {
                approvedBy,
                isApproved,
                ids: chunk
            };
            
            return PlacementDetailsTableService.getPlacementsApproved(campaignId, chunkPayload, pathParameters, versionOneApi)
                .then(response => ({
                    success: true,
                    data: response.data,
                    chunkIndex: index + 1,
                    chunkSize: chunk.length
                }))
                .catch(error => ({
                    success: false,
                    error: error,
                    chunkIndex: index + 1,
                    chunkSize: chunk.length
                }));
        });

        return Promise.all(chunkifiedPlacmentPromises)
            .then(results => {
                const successfulResults = results.filter(result => result.success);
                const failedResults = results.filter(result => !result.success);
                
                if (failedResults.length > 0) {
                    const totalPlacements = ids.length;
                    const failedPlacements = failedResults.reduce((sum, result) => sum + result.chunkSize, 0);
                    const successfulPlacements = totalPlacements - failedPlacements;
                    
                    const error = new Error(`Failed to approve ${failedPlacements} out of ${totalPlacements} placements. ${successfulPlacements} placements were successfully processed.`);
                    error.chunkErrors = failedResults.map(result => ({
                        chunkIndex: result.chunkIndex,
                        totalChunks: chunks.length,
                        error: result.error,
                        chunkSize: result.chunkSize
                    }));
                    error.successfulChunks = successfulResults.length;
                    error.totalChunks = chunks.length;
                    error.totalProcessed = totalPlacements;
                    error.failedPlacements = failedPlacements;
                    error.successfulPlacements = successfulPlacements;
                    throw error;
                }
                
                return {
                    data: {
                        updateResults: successfulResults.flatMap(result => result.data.updateResults || []),
                        totalProcessed: ids.length,
                        chunksProcessed: chunks.length
                    },
                    status: 200
                };
            });
    },
    
      /**
     * splitStringIntoArray function splits a string into an array based on the provided delimiter values and synthetic delimiter.
     * @param {string} namesString - The input string to be split into an array.
     * @param {string} schemaString - placement schema string.
     * @param {string} synthecticDelimiter - The synthetic delimiter used to separate a section of the input string.
     * @returns {Object} - object as schema key and placement taxonomy name value
     */
     splitPlacementStringIntoSchemaObject(namesString,schemaString,taxonomySchemaArray,synthecticDelimiter = null,isHidden = false,json=null){
         let scehmaAndValue = {};
        if(json){
            // If the placementData has json data, then we need to update the formData with the json data.
            scehmaAndValue  = PlacementDetailsTableService.updateFormDataWithJsonData(json, taxonomySchemaArray,isHidden);
        }else{
            if(!namesString  || !schemaString){
                return scehmaAndValue;
            }
            let finalTaxonomyArray = [];
            if(isHidden)
                finalTaxonomyArray = taxonomySchemaArray;
            else
                finalTaxonomyArray  = taxonomySchemaArray?.filter(val=>!val?.hidden);
            let schemaArrayOfString = schemaString.split('|');
            let valueArr = PlacementDetailsTableService.splitStringIntoArray(namesString,taxonomySchemaArray,synthecticDelimiter,isHidden,true)?.nameArr;
            if(valueArr.length > 2){
                schemaArrayOfString.forEach((name,index) => { //Iterates over each value in valueArr and updates the scehmaAndValue object based on the finalTaxonomyArray.
                    let value = valueArr[index]?.trim().toLowerCase();
                    let field = finalTaxonomyArray.find(field=> name == field.name || name == field.alias)
                    let optionIsExist = null;
                    
                    if(field?.fielditems.length){
                        optionIsExist = field?.fielditems?.find(option => [option.name?.trim().toLowerCase(), option.code?.trim().toLowerCase()].includes(value))
                    }else if(field?.dropDownValues?.length){
                        optionIsExist = field?.dropDownValues?.find(option => [option.label?.trim().toLowerCase(), option.value?.trim().toLowerCase()].includes(value));
                    }
                    if(field || optionIsExist){
                        scehmaAndValue[name] = valueArr[index];
                    }else if(!field){
                        scehmaAndValue[name] = "NU";
                    }
                    // finalTaxonomyArray?.forEach((field, fieldIndex) => { // Iterates over the finalTaxonomyArray and updates the scehmaAndValue object based on the field name and value in the valueArr
                    //     // let optionIsExist = field?.fielditems?.find(option => [option.name?.trim(), option.code?.trim()].includes(value))
                    //     if(field?.fielditems){
                    //         optionIsExist = field?.fielditems?.find(option => [option.name?.trim().toLowerCase(), option.code?.trim().toLowerCase()].includes(name.toLowerCase()))
                    //     }else{
                    //         optionIsExist = field?.dropDownValues?.find(option => [option.label?.trim().toLowerCase(), option.value?.trim().toLowerCase()].includes(name.toLowerCase()));
                    //     }
                    //     if(schemaArrayOfString.includes(field.name) || schemaArrayOfString.includes(field.alias) || ('NU' !== name && optionIsExist ) && index === fieldIndex && !scehmaAndValue[field.name]){
                    //         scehmaAndValue[name] = valueArr[index];
                    //     }
                    //     // else if(schemaArrayOfString.includes(field.name) && !scehmaAndValue.hasOwnProperty(field.name)){
                    //     //     scehmaAndValue[field.name] = value;
                    //     // }
                    //      else if(!schemaArrayOfString.includes(field.name) || !scehmaAndValue.hasOwnProperty(field.alias)) {
                    //         scehmaAndValue[name] = undefined;
                    //     }
                    // });

                });
                
                let emptyFieldCount = 0; //Assigning the values to the non-dropdown schema fields based on the index which are not found in the name string
                // Filter the valueArr based on the condition and assign the values to the non-dropdown schema fields based on the index which are not found in the name string
                const filteredValueLength = valueArr?.filter((item, index) => index !== valueArr?.length - 1 || item?.trim() !== '')?.length;
                schemaArrayOfString.forEach((schemaName,index) =>{
                    if(!scehmaAndValue[schemaName]){
                        let field = finalTaxonomyArray?.find(val=> val.name === schemaName);
                        if(field?.field_type !== 1){
                            if(schemaArrayOfString.length > filteredValueLength){
                                scehmaAndValue[schemaName] = valueArr[index-emptyFieldCount];
                            } else {
                                scehmaAndValue[schemaName] = valueArr[index];
                            }
                        } else {
                            emptyFieldCount++;
                        }
                    }
                });
            }
        }
        return scehmaAndValue;
    },

    /**
     * splitStringIntoArray function splits a string into an array based on the provided delimiter values and synthetic delimiter.
     *
     * @param {string} namesString - The input string to be split into an array.
     * @param {string} taxonomySchemaArray - The array of taxonomy schema fields objects.
     * @param {string} synthecticDelimiter - The synthetic delimiter used to separate a section of the input string.
     * @returns {Object} - An object containing the split nameArr array, syntheticId, nameLastIndex and delimiterArray.
     */
    splitStringIntoArray(namesString,taxonomySchemaArray,synthecticDelimiter = null, isHidden = false,passPendingValue = false,placementData){
        if(placementData?.taxonomy && synthecticDelimiter) {
            return PlacementDetailsTableService.createArrayFromJson(placementData, taxonomySchemaArray, synthecticDelimiter,isHidden);
        }
        
        let arr = [];
        let nameLastIndex = 0
        let namesArr =[];
        let synthecticId = null
        let finalTaxonomyArray = [];
        let isNameAndSchemaFieldMatch = true;
        let name = typeof namesString == 'string'?namesString : String(namesString);
        if(name && synthecticDelimiter){
            namesArr = name.split(synthecticDelimiter);
            name = namesArr[0];
        }
        if(isHidden)
            finalTaxonomyArray = taxonomySchemaArray;
        else
            finalTaxonomyArray  = taxonomySchemaArray?.filter(val=>!val?.hidden);
        if(!name || !(finalTaxonomyArray && finalTaxonomyArray?.length)){
            return {nameArr:[],syntheticId :'',nameLastIndex:null,isNameAndSchemaFieldMatch:false};
        }
        let delimiterArray = finalTaxonomyArray.map(val=> val.delimiterValue || val.delimiter_value);
        /* Iterates over the delimiterArray and splits the name string based on the delimiter values 
        and if the delimiter is not found then it will break the loop else assign name to an empty string */
        for(let i=0;i<delimiterArray.length;i++){
            let value = name.split(delimiterArray[i],1);
            arr.push(value[0]);
            let index = name.indexOf(delimiterArray[i]);
            if(index === -1 && i !== delimiterArray.length-1){
                name = '';
            }else if(index === -1 && i === delimiterArray.length-1){
                name = '';
            }else{
                name = name.slice(index+1);
            }
        }
        //if we and not split value in array 
        if(passPendingValue && name){
            arr.push(name);
            name = ''
        }
        // Check for the name string , if it's not empty(means taxonomy mismatch) then return the empty name array & 'isNameAndSchemaFieldMatch' as false
        if(name){
            return {nameArr:[],syntheticId :'',nameLastIndex:null,isNameAndSchemaFieldMatch:false};
        }
        nameLastIndex = arr.length-1;
        isNameAndSchemaFieldMatch = arr?.filter(val=>val !== '').length === delimiterArray.length;
        if(namesArr.length >= 2 && synthecticDelimiter){
            arr.push(':|'+namesArr[1]);
            synthecticId = synthecticDelimiter+namesArr[1];
            isNameAndSchemaFieldMatch = arr?.filter(val=>val !== '').length - 1 === delimiterArray.length;
        }
        arr = arr?.filter(val=>val !== '');
        return {nameArr:arr,syntheticId :synthecticId,nameLastIndex:nameLastIndex, delimiterArr: delimiterArray,isNameAndSchemaFieldMatch:isNameAndSchemaFieldMatch};
    },
    
    /**
     * Creates an array from the JSON data in the placement object.
     * @param {Object} placementData - The placement data object.
     * @param {Array} taxonomySchemaArray - The taxonomy schema array.
     * @param {string} synthecticDelimiter - The synthetic delimiter to use.
     * @returns {Array} The created array.
     */
    createArrayFromJson: (placementData, taxonomySchemaArray,synthecticDelimiter,isHidden) => {
        let nameArr = [];
        let jsonData = placementData.taxonomy;
        let synthecticId = '';
        if(jsonData.length && taxonomySchemaArray && taxonomySchemaArray?.length){
           jsonData.forEach((field) => {
                let value = taxonomySchemaArray?.find(item=>item.id == field.id);
                let allowCondition = value?.hidden ? isHidden : true;
                if(value && allowCondition){
                    nameArr.push(field.code);
                }
            });
        }
       
        if(synthecticDelimiter && placementData?.placements_id){
            // If synthecticDelimiter is provided and placements_id exists, append it to the nameArr
            synthecticId = synthecticDelimiter+placementData.placements_id;
            nameArr.push(synthecticId);
        }
        return {nameArr,syntheticId:synthecticId,nameLastIndex:nameArr.length-1,isNameAndSchemaFieldMatch: true};
    },

    /**
     * Creates a string representation of the JSON data.
     * @param {Array} jsonArray - The JSON data array.
     * @param {string} label - The label to use for the string representation.
     * @param {boolean} useHiddenFiled - Whether to include hidden fields.
     * @param {Array} taxonomyData - The taxonomy data array.
     * @param {boolean} isNewCreation - Whether this is a new creation.
     * @returns {string} The string representation of the JSON data.
     */
    createStringFromJson: (jsonArray,label,useHiddenFiled=false,taxonomyData, isNewCreation=false) => {
        let name = '';
        // Build a lookup map for uploaded field names and aliases by ID
        const taxonomyFieldMap = new Map();
        taxonomyData?.forEach(field => {
            taxonomyFieldMap.set(field.id, field);
        });

        let lastAddedDelimiter = null;
        
        if(jsonArray.length){            
            let totalLength = jsonArray.length;
            jsonArray.forEach((field,index) => {
                const txonomyField = taxonomyFieldMap.get(field.id);
                let delimeter = label === 'field_name' ? '|' : field.delimiter;
                let allowCondition = txonomyField?.hidden ? useHiddenFiled : true;
                if(allowCondition && txonomyField){
                    if(isNewCreation && txonomyField.field_type === 10){
                        field[label] = "{TaxonomyValueID}"
                    }
                    if(totalLength-1 === index){
                        name = name + field[label];
                        lastAddedDelimiter = null;
                    }else{
                        // if the field is not last then add delimiter
                        name = name + field[label] + delimeter;
                        lastAddedDelimiter = delimeter;
                    }
                }
            });
        }
        // this is added just to check if last added one is delimiter when taxonomy & jsonArray length are not matching,
        // if not matching, remove the last added delimiter
        if(lastAddedDelimiter){
            name = name.slice(0, -1);
        }
        return name;
    },

    /**
     * create Placement name string accroding to delimeter
     * @param {array} schemaDropDownArray 
     * @param {array} nameArr 
     * @param {array} schemaNameStringArr 
     * @returns 
     */
    createStringFromArray(schemaDropDownArray,nameArr,schemaNameStringArr, isOverride = false){
        if (isOverride) {
            let nameString = '';
            schemaNameStringArr.forEach((value,index)=>{
                let field = schemaDropDownArray?.find(item=>item.name==value || item.alias==value);
                if(index === nameArr.length-1){
                    nameString = nameString+nameArr[index];
                }else{
                    nameString = nameString+nameArr[index]+( field?.delimiterValue || field?.delimiter_value );
                }
            });
            return nameString
        } else {
            let nameString = '';
            const updatedSchemaDropDownArray = schemaDropDownArray?.filter(val=>!val?.hidden);
            schemaNameStringArr.forEach((value,index)=>{
                let field = updatedSchemaDropDownArray?.find(item=>item.name==value || item.alias==value);
                if(index === nameArr.length-1){
                    nameString = nameString+nameArr[index];
                }else{
                    nameString = nameString+nameArr[index]+( field?.delimiterValue || field?.delimiter_value );
                }
            });
            return nameString
        }
    },

    /**
     * Copies the given text to the clipboard and/or shows the toast message based on the status.
     * @param {string} textToCopy The text to copy to the clipboard.
     * @returns {void}
     */
    copyTextToClipboard(textToCopy) {
        navigator.clipboard.writeText(textToCopy)
            .then(() =>{
                AlertMessagesService.showSuccessToastMessage("Copied to clipboard!");
            })
            .catch(function(err) {
                AlertMessagesService.showErrorToastMessage("Failed to copy to clipboard", err);
            });
    },

    /**
     * Creates an empty data structure for the channels.
     * @param {Object} campaignObj 
     * @returns {void}
     */
    createEmptyChannelsData(campaignObj) {
        let nestedData = [];
        campaignObj?.channels?.forEach((channel, index) => {
        
            let channelObj = {
                "placement_taxonomy": channel.channel_name,
                "placement_display_name": channel.channel_display_name,
                title: "Channel",
                planned_cost: "",
                planned_cost_local: "",
                unit_amount: 0,
                id: "channelRow" + index,
                nestedData: [],
            };
            channel.publishers.forEach((publisher, publisherIndex) => {
                if (publisher?.publisher_type!== "Ad Serving" && publisher?.publisher_type!== "Ad Verification") {
                    let publisherObj = {
                        "placement_taxonomy": publisher?.publisher_name?.toUpperCase(),
                        "placement_display_name": publisher?.publisher_display_name,
                        title: "Publisher",
                        planned_cost: "",
                        planned_cost_local: "",
                        unit_amount: 0,
                        channel: channel.channel_name,
                        id: "channelChild" + publisherIndex + index,
                    };
                    channelObj.nestedData.push(publisherObj);
                }
            });
            if(channelObj.nestedData.length > 0)
                nestedData.push(channelObj);
        });
        return nestedData;
    },

    /**
     * Converts a flat array of data into a nested structure.
     * @param {Array} data - The flat array of data to be converted.
     * @returns {Array} - The nested structure of the data.
     */
    convertToNestedStructure : (data, packageType = '') => {

        return new Promise(function(resolve, reject) {
            const result = [];
            const idMap = {};
          
            // First pass to create a mapping of objects by their ID
            for (const item of data) {
              const id = item.id;
              idMap[id] = { ...PlacementDetailsTableService.prepareCopyPayload(item) };
            }
          
            // Second pass to build the result array by nesting child items
            data?.forEach((item, itemIndex) => {
                const parentId = item.parent_id;
                if (parentId) {
                  // If the item has a parent, add it as a child to its parent
                  if (idMap[parentId]) {
                    if (!idMap[parentId].childLineItems) {
                      idMap[parentId].childLineItems = [];
                    }
                    idMap[parentId].childLineItems.push(idMap[item.id]);
                  }
                } else {
                  // If it doesn't have a parent, it's a top-level item
                  result.push(idMap[item.id]);
                }
    
                if (packageType === item?.package_type && parentId && ['DSP'].includes(item?.package_type)) {
                    result.push(idMap[item.id])
                }
    
                if (itemIndex+1 === data?.length) {
                    resolve(result);
                }
            });
          });


      },

    /**
       * Removes a key from an object or its nested objects.
       * @param {Object} obj - The object from which the key should be removed.
       * @param {string} key - The key to be removed.
       * @returns {void}
       */
    removeKey: (obj, key) => {
        if (!obj || typeof obj !== 'object') {
            return;
        }
        if (Array.isArray(obj)) {
            obj.forEach(item => PlacementDetailsTableService.removeKey(item, key));
        } else {
            delete obj[key];
            Object.values(obj).forEach(value => PlacementDetailsTableService.removeKey(value, key));
        }
    },


    /**
    * Gets the current date and time or a specific date and time based on the input provided.
    *
    * @category Date
    * @param {string} [dateInput=''] - The specific date and time to retrieve. If not provided, the current date and time will be used.
    * @returns {string} Returns the current date and time or a specific date and time as a string formatted as "YYYY-MM-DDTHH:MM:SS".
    * @example
    *
    * getDate()
    * // => '2022-04-28T13:30:00'
    *
    * getDate('2022-04-28T13:30:00')
    * // => '2022-04-28T13:30:00'
    */
    getDate: (dateInput = '') => {
        let today;
        if (dateInput) {
            today = new Date(dateInput);
        } else {
            today = new Date();
        }

        // Get the individual components of the date and time
        const year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
        const day = today.getDate().toString().padStart(2, '0');
        const hours = today.getHours().toString().padStart(2, '0');
        const minutes = today.getMinutes().toString().padStart(2, '0');
        const seconds = today.getSeconds().toString().padStart(2, '0');

        // Format the date and time as desired (e.g., "YYYY-MM-DDTHH:MM:SS")
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    },

    /**
     * @function onPlacementCopySuccess
     * @description Handles the success case for copying placements.
     * @param {object} result - The result object from the API call.
     * @param {function} setState - The setState function to update the component state.
     */
    onPlacementCopySuccess: (result, resetStateAndSendAlerts) => {
        let respMsgArr = [];
        result?.data?.result.forEach((copyResult, index) => {
            if (copyResult?.status === 'success') {
                respMsgArr.push({ type: "success", title: `Placement is copied`, "bodyMsgArr": [html`Placement name:<br/>${copyResult?.placementTaxonomy}`] });

                if (copyResult?.childLineItems?.length) {
                    copyResult?.childLineItems.forEach((childItem, childIndex) => {
                        if (childItem?.status === 'success') {
                            respMsgArr.push({ type: "success", title: `Placement is copied`, "bodyMsgArr": [html`Placement name:<br/>${childItem?.placementTaxonomy}`] });
                        }

                        if (childItem?.childLineItems?.length) {
                            childItem?.childLineItems.forEach((nestedChildItem, nestedChildIndex) => {
                                if (nestedChildItem?.status === 'success') {
                                    respMsgArr.push({ type: "success", title: `Placement is copied`, "bodyMsgArr": [html`Placement name:<br/>${nestedChildItem?.placementTaxonomy}`] });
                                }
                            });
                        }
                    })
                }

            } else {
                respMsgArr.push({ type: "danger", title: "Placement is not copied", "bodyMsgArr": [html`Placement name:<br/>${copyResult?.placementTaxonomy}`, html`Error description:<br/>${copyResult?.validation}`] })
            }

            if (index + 1 === result?.data?.result.length) {
                resetStateAndSendAlerts(respMsgArr);
            }
        });
    },

    /**
     * @function onPlacementCopyFailure
     * @description Handles the failure case for copying placements.
     * @param {object} error - The error object from the API call.
     * @param {function} setState - The setState function to update the component state.
     */
    onPlacementCopyFailure: (error, resetSelctedItems) => {
        let respMsgArr = [];
        error?.data?.result.forEach((copyResult, index) => {
            if (copyResult?.status === 'error') {
                respMsgArr.push({ type: "danger", retryBtnText: 'Retry', retryBtnEvent: () => PlacementDetailsTableService.onPlacementCopyFailure(error, resetSelctedItems), title: `Placement is not copied`, "bodyMsgArr": [html`Placement name:<br/>${copyResult?.placementTaxonomy}`, html`Error description:<br/>${copyResult?.validation}`] });

                if (copyResult?.childLineItems?.length) {
                    copyResult?.childLineItems.forEach((childItem, childIndex) => {
                        if (childItem?.status === 'error') {
                            respMsgArr.push({ type: "danger", retryBtnText: 'Retry', retryBtnEvent: () => PlacementDetailsTableService.onPlacementCopyFailure(error, resetSelctedItems), title: `Placement is not copied`, "bodyMsgArr": [html`Placement name:<br/>${childItem?.placementTaxonomy}`, html`Error description:<br/>${childItem?.validation}`] });
                        }

                        if (childItem?.childLineItems?.length) {
                            childItem?.childLineItems.forEach((nestedChildItem, nestedChildIndex) => {
                                if (nestedChildItem?.status === 'error') {
                                    respMsgArr.push({ type: "danger", retryBtnText: 'Retry', retryBtnEvent: () => PlacementDetailsTableService.onPlacementCopyFailure(error, resetSelctedItems), title: `Placement is not copied`, "bodyMsgArr": [html`Placement name:<br/>${nestedChildItem?.placementTaxonomy}`, html`Error description:<br/>${nestedChildItem?.validation}`] });
                                }
                            });
                        }
                    })
                }

                if (index + 1 === error?.data?.result?.length) {
                    AlertMessagesService.showMultipleAlerts(respMsgArr);
                    resetSelctedItems();
                }

            }
        })
    },

    /**
     * Copies placements of a campaign
     * @param {string} campaignId - ID of the campaign to copy placements to
     * @param {Array} payload - An array of objects containing placement information to be copied
     * @return {Promise<AxiosResponse>} A promise that resolves to the Axios response
     */
    bulkPlacementsCopy: (campaignId, payload, versionOneApi) => {
        const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
        return axios
            .post(url + '/' + campaignId + '/placements/copy',
                payload,
                {
                    headers: {
                        ansid: authansid,
                        clientid: Utils.getRouteParam("clientid")
                    }
                })
            .then((response) => {
                return response;
            })
    },

    /**
     * Retrieves the value of a static field and displays it in an input element.
     * 
     * @function getStaticField
     * @param {number} index - The index of the field.
     * @param {Object} field - The field object containing field information.
     * @param {Object} state - The current state of the form.
     * @returns {JSX.Element} The input element displaying the value of the static field.
     */
    getStaticField: (index, field, state) => {
        return (
            <div
                className={`input-container`}
                key={index}
            >
                <label htmlFor={field.name + index}>
                    {field.alias ? field.alias : field.name}
                </label>
                <input
                    id={field.name + index}
                    key={field.name + index}
                    fieldtype="taxonomy"
                    fieldid={field.id}
                    fieldname={field.name}
                    maxLength={field.character_limit}
                    value={state.formData[field.name]}
                    placeholder={field.name}
                    disabled
                ></input>
            </div>
        );
    },

    getErrorMessage: (result, placementName) => {
        if(result?.validationResults && result?.validationResults[placementName]){   // Check if validationResults exist and contain an entry for the given placement
            return result?.validationResults[placementName];     // Return the specific validation message for this placement
        } else{
            return result?.message || result?.validation;     // If no specific validation message, return general message or validation
        }
    },

    /**
     * Creates a template string based on the given fields.
     *
     * @param {Array<Object>} fields - An array of objects representing the fields to include in the template string.
     * Each object should have the following properties:
     * - `hidden`: A boolean indicating whether the field should be hidden or not.
     * - `field_type`: An integer representing the type of the field. If it's equal to 10, the field will be treated as a taxonomy field.
     * - `delimiter_value`: A string representing the delimiter value for the field.
     *
     * @return {string} A string containing the values of the fields, separated by the appropriate delimiter.
     */
    createTemplateString: (fields) => {
        const result = { data: '', delimiters: [] }
        if (!fields?.length) return result;
        const delimeterValues = [];
        result.data = fields
            .filter((field) => !field?.hidden)
            .reduce((taxonomyString, field) => {
                const delimiterValue = field?.field_type === 10 ? 'taxonomyId' : 'string';
                delimeterValues.push(field?.delimiter_value);
                return taxonomyString + delimiterValue + field?.delimiter_value;
            }, '')
            .slice(0, -1);
        delimeterValues.pop()
        result.delimiters = delimeterValues;
        return result;
    },

    /**
    * Recursively removes empty or undefined `nestedData` arrays from the input data.
    * @param {Array} data - The array of objects with nestedData property.
    * @returns {Array} - A new array with empty or undefined nestedData arrays removed.
    */
    removeEmptyNestedData: (data) => {
        return data.map((item) => {
            if (Array.isArray(item.nestedData)) {
                // Recursively call removeEmptyNestedData on nestedData.
                const removeNestedKey = PlacementDetailsTableService.removeEmptyNestedData(item.nestedData);
                // Check if nestedData is not empty after removal.
                if (removeNestedKey && removeNestedKey.length > 0) {
                    item.nestedData = removeNestedKey;
                } else {
                    delete item.nestedData;
                }
            }
            return item;
        });
    },

    /**
     * Function is use to create object for edit form
     * @param {Object} placementData 
     * @param {array} taxonomyData 
     * @param {array} defaultTaxonomyData 
     * @returns 
     */
    createformDataForEditPlacement(placementData,taxonomyData,defaultTaxonomyData,socialProgrammaticFlag, isLocal, currency){
        let defaultData = {};
        defaultData["Placement Name"] = placementData["placement_taxonomy"];
        defaultData["Parameter Code"] = placementData["parameter_code"];
        defaultData["Parameter Code Schema"] = placementData["parameter_code_taxonomy_schema"];
        defaultData["Parameter Code Display Name"] = placementData["parameter_code_taxonomy_display"];
        let schemaDelimiterValue = "|";
        
        let taxonomyNameString= placementData["override_taxonomy"]? placementData["overriden_placement_taxonomy"]:(placementData["placement_taxonomy"]?placementData["placement_taxonomy"]:"")
        let editFormData = [];
        let scehmaAndValue = {};
        if(!placementData?.taxonomy?.length){
            editFormData = PlacementDetailsTableService.splitStringIntoArray(taxonomyNameString, taxonomyData?.fields,':|',true,false,placementData).nameArr;
        }else{
            scehmaAndValue  = PlacementDetailsTableService.updateFormDataWithJsonData(placementData['taxonomy'] , taxonomyData.fields,false);
            // editFormData = Object.values(scehmaAndValue);
        }

        let schemaArr = ( placementData["taxonomy_schema"] || "").split(schemaDelimiterValue);
        if(!placementData["override_taxonomy"]){
        for(let index  in schemaArr){
            const fieldName = schemaArr[index];
            if(!placementData?.taxonomy?.length){
                defaultData[fieldName] = editFormData[index];
            }else{
                defaultData[fieldName] = scehmaAndValue[fieldName];
            }
        }
        let { taxonomySelectedValueJson } = PlacementUtils.createNames(defaultData,taxonomyData,true);
        placementData['taxonomy'] = taxonomySelectedValueJson;
        }else{
            placementData['isOverride'] = placementData["override_taxonomy"];
        }    

        // The below code is splitting the values of two properties, "parameter_code" and
        // "parameter_code_taxonomy_schema", from an object called "placementData" using a delimiter. 
        let parameterEditFormData =  PlacementDetailsTableService.splitStringIntoArray(placementData["parameter_code"],defaultTaxonomyData).nameArr ;
        let parameterSchema = (placementData["parameter_code_taxonomy_schema"] || "").split(schemaDelimiterValue);
        for(let index  in parameterSchema){
        defaultData["Parameter Code "+parameterSchema[index]] = parameterEditFormData[index];
        }     

        // converting the date in format (Mon DD, YYYY) with Utils.formatDateObject function 
        defaultData["Flight Start"] = placementData["flight_start"] ? Utils.formatDateObject(placementData["flight_start"]) : "";
        defaultData["Flight End"] = placementData["flight_end"] ? Utils.formatDateObject(placementData["flight_end"]) : "";
        if(isLocal && currency){
            defaultData["Rate"] = (placementData["rate_local"] || placementData["rate_local"] === 0) ? placementData["rate_local"] : "";
            defaultData["Planned Cost"] = placementData["planned_cost_local"] ? placementData["planned_cost_local"] : "";
        }else{
            defaultData["Rate"] = (placementData["rate"] || placementData["rate"] === 0) ? placementData["rate"] : "";
            defaultData["Planned Cost"] = placementData["planned_cost"] ? placementData["planned_cost"] : "";
        }
        
        defaultData["Unit Amount"] = (placementData["unit_amount"] || placementData["unit_amount"] === 0) ? placementData["unit_amount"] : "";
        defaultData["costMethod"] = placementData["cost_method"];
        let placementNameArray = defaultData["Placement Name"].split(':|');
        this.synthecticId = placementData.placements_id;
        defaultData["Placement Name"] = placementNameArray[0];
        defaultData["costMethod"] = placementData["cost_method"];
        defaultData["Placement Name"] = placementData["placement_taxonomy"];
        defaultData["Placement Display Name"] = placementData["placement_taxonomy_display"];
        defaultData["Placement Schema"] = placementData["taxonomy_schema"];
        defaultData["programmaticType"] = CreatePlacementOrPackageService.getProgrammaticType(placementData["package_type"],socialProgrammaticFlag);
        defaultData['taxonomy_client_id'] = taxonomyData.clientid,
        defaultData['taxonomy_schema_id'] = taxonomyData.id
        return defaultData;
    },
    
    /**
    * Fetches the placements for a given campaign with delivered taxonomies included.
    *
    * @param {string} campaignId - The ID of the campaign to fetch the placements for.
    * @param {object} [filterObj] - An optional filter object to apply to the placements.
    * @returns {Promise} A Promise that resolves to the response object from the API.
    */
    getPlacementsWithDelivered: (campaignId, filterObj, versionOneApi, hasNext = null, sourceSystem) => {
        let url = '';
        let firlterParams = {includeDeliveredTaxonomies: true, show_creatives: "distributed"};
        if(sourceSystem){
            firlterParams.source_system = sourceSystem;
        }
        if(hasNext){
            url = hasNext;
            firlterParams = {};
        }else{
            url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}/${campaignId}/placements` : `${Constants.CampaignDataUrlV2}/${encodeURIComponent(campaignId)}/placements`;
            if (filterObj) {
                //if child campaign's placement feching
                if(filterObj?.parent_amd_campaign_id){
                    url = `${url}?parent_amd_campaign_id=${filterObj?.parent_amd_campaign_id}`
                    firlterParams = {...filterObj.firlterParams,is_delete:filterObj.is_delete,page_no:filterObj.page_no,page_size:filterObj.page_size,...firlterParams};
                }else{
                    firlterParams = {...filterObj,...firlterParams}
                }
            }

        }
        return axios.get(url,
                {
                    params: { ...firlterParams},
                    headers: { ansid: authansid, clientid: Utils.getRouteParam("clientid") }
                })
            .then((response) => response)
            .catch((error) => Promise.reject(error))
    },

    /**
     * Calculates the total fees for a given publisher.
     * 
     * @param {Array} data - The array of data items.
     * @param {string} fees - The fee property to calculate.
     * @param {string} publisher - The publisher to filter by.
     * @returns {string} The total fees for the given publisher, formatted as a currency string. If the total fees is 0, returns an empty string.
     */
    getPublisherFees: (data, fees, item) => {
        const publisherData = data?.filter(item1 => item1?.site === item?.placement_taxonomy && item1?.placement_type === item?.channel);
        const publisherPlacements = publisherData?.filter(item => ["Standalone", "Package", "ProgrammaticPackage"].includes(item?.package_type));
        const publisherAdVerificationFees = publisherPlacements.reduce((total, item) => total + (item[fees] || 0), 0);
        return publisherAdVerificationFees ? publisherAdVerificationFees?.toLocaleString('en-US', {style: "currency", currency: "USD"}) : '';
    },

    /**
     * Calculates the total fees for a given channel.
     * 
     * @param {Array} data - The array of data items.
     * @param {string} fees - The fee property to calculate.
     * @param {string} channel - The channel to filter by.
     * @returns {string} The total fees for the given channel, formatted as a currency string. If the total fees is 0, returns an empty string.
     */
    getChannelFees: (data, fees, channel) => {
        const channelData = data?.filter(item => item?.placement_type === channel);
        const channelPlacements = channelData?.filter(item => ["Standalone", "Package", "ProgrammaticPackage"].includes(item?.package_type));
        const channelAdVerificationFees = channelPlacements.reduce((total, item) => total + (item[fees] || 0), 0);
        return channelAdVerificationFees ? channelAdVerificationFees?.toLocaleString('en-US', {style: "currency", currency: "USD"}) : '';
    },
    
    /**
     * Gets the selected tier based on the placement type and supplier.
     *
     * @param {Object} campaignObj - The campaign object containing the channels and publishers.
     * @param {string} placementType - The placement type to search for in the channels.
     * @param {string} supplier - The supplier to search for in the publishers.
     * @returns {Object|undefined} The selected publisher object or undefined if not found.
     */
    getSelectedTier: (campaignObj, placementType, supplier) => {
        const selectedChannel = campaignObj?.channels?.find(channel => channel?.channel_name?.toLowerCase() === placementType?.toLowerCase());
        const selectedPubliser = selectedChannel?.publishers?.find(publisher => publisher?.publisher_name?.toLowerCase()?.replace(/ +/g, "") === supplier?.toLowerCase()?.replace(/ +/g, ""));
        return selectedPubliser;
    },

    /**
     * Updates the parent tier information of an item.
     *
     * @param {Object} item - The item to update.
     * @param {string} parentTierType - The type of the parent tier.
     * @param {string|number} parentTierId - The ID of the parent tier.
     * @returns {void}
     */
    updateParentTier: (item, parentTierType, parentTierId) => {
        item['parent_tier_type'] = parentTierType || '';
        item["parent_tier_id"] = parentTierId || '';
    },

    /**
       * Function is to which Parameter code values user can edit which not.
       * @param {boolean} isChildPlacement is placement child type
       * @param {string} title value tile (publisher or Buy Type)
       * @param {Object} placement placement all details
       * @returns if condition match then return ture not allowing user else user can edit value
       */
    isEditableInlineParameterCode(title, placement) {
        if (placement?.parent_id && ['Publisher', 'Supplier Code', 'Supplier', 'Buy Type'].includes(title)) {
            return true;
        } else if (title === 'Cost Method') {
            return true;
        } else {
            return false;
        }
    },

    /**
     * Deletes a placement for a given campaign.
     *
     * @function deletePlacement
     * @param {string} campaignId - The ID of the campaign.
     * @param {Object} payload - The payload containing the placement data to be deleted.
     * @param {string} versionOneApi - The version of the API to use ("V1" or "V2").
     * @returns {Promise} - A Promise that resolves to the response from the API call.
     */
    deletePlacement: (campaignId, payload, versionOneApi) => {
        const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;

        return axios
            .put(url + '/' + campaignId + '/placements',
                payload,
                {
                    headers: {
                        ansid: CookieService.getCookie("ANsid"),
                        clientid: Utils.getRouteParam("clientid")
                    }
                })
            .then((response) => {
                return response;
            })
    },

    /**
     * Updates the form data with values from the JSON array based on the taxonomy data.
     * @param {Array} taxonomyArray - The JSON array containing the data to update.
     * @param {Array} taxonomyData - The taxonomy data to use for mapping.
     * @returns {Object} The updated form data.
     */
    updateFormDataWithJsonData: (taxonomyArray,taxonomyData,useHiddenFiled) => {
        let formData = {};
        // Build a lookup map for uploaded field names and aliases by ID
        const taxonomyFieldMap = new Map();
        taxonomyData?.forEach(field => {
            let allowCondition = field.hidden ? useHiddenFiled : true;
            if(allowCondition){
                taxonomyFieldMap.set(field.id, field);
            }
        });
        
        // Check for taxonomyArray field type
        taxonomyArray = Array.isArray(taxonomyArray) ? taxonomyArray : [];
        taxonomyArray?.filter(item => {
            const txonomyField = taxonomyFieldMap.get(item.id);
            return txonomyField;
        })
        .sort((a, b) => a.order - b.order)
        .forEach(item => {
            const txonomyField = taxonomyFieldMap.get(item.id);
            let fieldName = txonomyField.name || txonomyField.alias
            formData[fieldName] = item.code;
        });
        return formData;
    },
    
    /**
     * Creates an object containing the form edit data.
     * @param {Array} taxonomyData - The taxonomy data array.
     * @param {Object} placementData - The placement data object.
     * @returns {Object} The form edit data object.
     */
    getFormEditData : (taxonomyData, placementData, placementColumn = null) => {
        let isHiddenFields = false;
        let hiddenSchemaArr = [];
        let notHiddenSchemaArr = [];
        for (let i = 0; i < taxonomyData?.length; i++) {
            if (taxonomyData[i].hidden) {
            isHiddenFields = true;
            hiddenSchemaArr.push(taxonomyData[i].name);        
            } else {
            notHiddenSchemaArr.push(taxonomyData[i].name);
            hiddenSchemaArr.push(taxonomyData[i].name); 
            }
        }
        let taxonomyNameString;
        let schemaArr = [];
        if (!isHiddenFields) {
            taxonomyNameString = placementColumn === "parameter_code" ? placementData["parameter_code"] : (placementData["override_taxonomy"] ? placementData["overriden_placement_taxonomy"] : (placementData["placement_taxonomy"] ? placementData["placement_taxonomy"] : ""));
            schemaArr = notHiddenSchemaArr;
        } else {
            taxonomyNameString = placementColumn === "parameter_code" ? placementData["parameter_code"] : (placementData["overriden_placement_taxonomy"] ? placementData["overriden_placement_taxonomy"] : (placementData["placement_taxonomy"] ? placementData["placement_taxonomy"] : ""));
            schemaArr = hiddenSchemaArr;
        }
        let placementJson = placementColumn === "parameter_code" ? null : (placementData?.taxonomy ? placementData.taxonomy: null);
        let hidenSchemaString = schemaArr.join('|')
        let editFormData = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(taxonomyNameString, hidenSchemaString, taxonomyData, ':|', isHiddenFields,placementJson);
        return { schemaArr, editFormData }
    },
    /**
     * Compares the taxonomy fields with the edit data to ensure all required fields are present.
     * @param {Array} taxonomyFields - The array of taxonomy fields.
     * @param {Object} editData - The edit data object.
     * @param {string} currentSchema - The current schema string.
     * @param {Array} taxonomyArray - The taxonomy array to compare IDs with.
     * @returns {boolean} True if all required fields are present, false otherwise.
     */
    compareTaxonomyAndData: (taxonomyFields, editData, currentSchema, taxonomyArray) => {
        // Compare taxonomy IDs with taxonomyFields if taxonomyArray is provided
        if(taxonomyArray && taxonomyArray.length) {
            const taxonomyIdSet = new Set(taxonomyArray.map(item => item.id));
            const fieldIdSet = new Set(taxonomyFields?.map(field => field.id));
            
            // Check if lengths match
            if (taxonomyIdSet.size !== fieldIdSet.size) {
                return false;
            }
            
            // Check if all IDs from fieldIdSet are present in taxonomyIdSet
            for (const id of fieldIdSet) {
                if (!taxonomyIdSet.has(id)) {
                    return false;
                }
            }

            return true;
        }
        
        // Compare the taxonomy data with the current schema if there is no taxonomyArray
        if (!taxonomyFields || !editData) return false;
        taxonomyFields = taxonomyFields?.filter(field => !field.hidden);
        let editDataKeys = Object.keys(editData);
        for (let i = 0; i < taxonomyFields.length; i++) {
            let field = taxonomyFields[i];
            if (!editDataKeys.includes(field.name) && !editDataKeys.includes(field.alias)) {
                return false;
            }
        }

        // Second check to validate new & old schema, even if all values are matching
        let newSchema = taxonomyFields?.map(field => field.name || field.alias);
        let newSchemaWithAlias = taxonomyFields?.map(field => field.alias);
        let oldSchema = currentSchema ? currentSchema.split('|') : [];
        if (newSchema.length !== oldSchema.length) return false;

        // Third check to compare new & old schema values
        for (let i = 0; i < newSchema.length; i++) {
            if (newSchema[i]?.trim() !== oldSchema[i]?.trim() && newSchemaWithAlias[i]?.trim() !== oldSchema[i]?.trim()) {
                return false;
            }
        }

        return true;
    },

    /**
     * Returns an object of default parameter code values based on the default taxonomy fields.
     * If a placement's parameter_code is null/empty, this function is used to populate
     * a default mapping where each field name maps to the string 'NA'.
     *
     * @param {Array<Object>} defaultTaxonomyFields - array of taxonomy field definitions
     * @returns {Object} mapping of fieldName -> 'NA'
     */
    getDefaultValuesForParameterCode: (defaultTaxonomyFields) => {
        const result = {};
        if (!defaultTaxonomyFields || !defaultTaxonomyFields.length) return result;
        defaultTaxonomyFields.forEach((field) => {
            const fieldName = field?.name || field?.alias || `field_${field?.id}`;
            result[fieldName] = 'NA';
        });
        return result;
    },

    /**
     * Downloads the default placement template for the current client.
     * Makes a POST request to the placement template API to generate and retrieve
     * the template file for placement imports.
     * @function downloadPlacementTemplate
     * @returns {Promise<Object>} A promise that resolves to the response data
     */
    downloadPlacementTemplate: () => {
        const url = `${Constants.PlacementTemplateUrl}/placement-templates/${Utils.getRouteParam("clientid")}?type=placement&default=true`;
        return axios.post(url, {}, {
            headers: {
                ansid: CookieService.getCookie("ANsid"),
                clientid: Utils.getRouteParam("clientid"),
            }
        })
        .then(response => {
            return response.data;
        })
    },

    /**
     * Uploads a placement template file to import placements for the current client.
     * Makes a POST request to the template import API with the provided file data.
     * @function uploadPlacementTemplate
     * @param {Object} fileData - The file data object containing the template information in base64String format
     * @returns {Promise<Object>} A promise that resolves to the response data
     */
    uploadPlacementTemplate: (fileData) => {
        const url = `${Constants.PlacementTemplateUrl}/import-template/${Utils.getRouteParam("clientid")}`;
        return axios.post(url, fileData, {
            headers: {
                ansid: CookieService.getCookie("ANsid"),
                clientid: Utils.getRouteParam("clientid")
            }
        })
        .then(response => {
            return response.data;
        })
    }
}
